import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);
const userStatut = localStorage.getItem("currentUserStatus")

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
  <React.Suspense fallback={loading()}>
  <Route
    {...rest}
    render={props =>
      auth.isAuthenticated === true ? (
        <Component {...props}  />
      ) : (
        <Redirect exact  to="/login" />
      )
    }
  />
  </React.Suspense>
);
PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  auth: state.auth,
  currentStatus: state.rh.currentUserStatus,
});
export default connect(mapStateToProps)(PrivateRoute);











